import { render, staticRenderFns } from "./StaffAssignment.vue?vue&type=template&id=3676f95f&scoped=true&"
import script from "./StaffAssignment.vue?vue&type=script&lang=js&"
export * from "./StaffAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676f95f",
  null
  
)

export default component.exports